<template>
    <Card>
        <template v-slot:icon><i class="font-size-h2" :class="[icon]"/></template>
        <template v-slot:title>{{ title }}</template>
        <template v-slot:toolbar>
            <button :disabled="disabled" class="btn btn-sm"
                    :class="[editButtonClass || 'btn-primary', {'disabled' : disabled}]"
                    @click="rerouteToStep(route)">
                <i class="fas mr-1" :class="[editButtonIcon || 'fa-pen']"></i>
                {{ editButtonText || __('actions.edit') }}
            </button>
        </template>

        <div v-for="subStep in subSteps" class="my-3">
            <h6>{{ subStep.title }}</h6>
            <p class="text-muted">{{ subStep.shortDescription }}</p>
        </div>
    </Card>
</template>

<script>
import Card from '@components/Cards/Card';

export default {
    name: 'AccountSetupCard',
    components: {Card},
    props: {
        subSteps: Array,
        title: String,
        icon: String,
        editButtonClass: String,
        editButtonIcon: String,
        editButtonText: String,
        route: String,
        disabled: Boolean,
    },
    methods: {
        rerouteToStep(route) {
            this.$inertia.get(route);
        },
    },
};
</script>
